export const PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_REQUEST =
  "PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_REQUEST";
export const PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_SUCCESS =
  "PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_SUCCESS";
export const PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_FAIL =
  "PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_FAIL";
export const PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_RESET =
  "PAYMENT_TENANT_CREATE_SUBSCRIPTION_AUTO_TAX_RESET";

export const PAYMENT_TENANT_SETUP_INTENT_REQUEST =
  "PAYMENT_TENANT_SETUP_INTENT_REQUEST";
export const PAYMENT_TENANT_SETUP_INTENT_SUCCESS =
  "PAYMENT_TENANT_SETUP_INTENT_SUCCESS";
export const PAYMENT_TENANT_SETUP_INTENT_FAIL =
  "PAYMENT_TENANT_SETUP_INTENT_FAIL";
export const PAYMENT_TENANT_SETUP_INTENT_RESET =
  "PAYMENT_TENANT_SETUP_INTENT_RESET";

export const PAYMENT_TENANT_REMOVE_ALL_TAXIDS_REQUEST =
  "PAYMENT_TENANT_REMOVE_ALL_TAXIDS_REQUEST";
export const PAYMENT_TENANT_REMOVE_ALL_TAXIDS_SUCCESS =
  "PAYMENT_TENANT_REMOVE_ALL_TAXIDS_SUCCESS";
export const PAYMENT_TENANT_REMOVE_ALL_TAXIDS_FAIL =
  "PAYMENT_TENANT_REMOVE_ALL_TAXIDS_FAIL";
export const PAYMENT_TENANT_REMOVE_ALL_TAXIDS_RESET =
  "PAYMENT_TENANT_REMOVE_ALL_TAXIDS_RESET";

export const PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_REQUEST =
  "PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_REQUEST";
export const PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_SUCCESS =
  "PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_SUCCESS";
export const PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_FAIL =
  "PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_FAIL";
export const PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_RESET =
  "PAYMENT_TENANT_CHECK_UPDATE_VAT_CODE_RESET";

export const PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_REQUEST =
  "PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_REQUEST";
export const PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_SUCCESS =
  "PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_SUCCESS";
export const PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_FAIL =
  "PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_FAIL";
export const PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_RESET =
  "PAYMENT_TENANT_UPDATE_ADDRESS_CREATE_SUBSCRIPTION_RESET";

export const PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_REQUEST =
  "PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_REQUEST";
export const PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_SUCCESS =
  "PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_SUCCESS";
export const PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_FAIL =
  "PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_FAIL";
export const PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_RESET =
  "PAYMENT_TENANT_GET_STRIPE_BILLING_DETAILS_RESET";

export const PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_REQUEST =
  "PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_REQUEST";
export const PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_SUCCESS =
  "PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_SUCCESS";
export const PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_FAIL =
  "PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_FAIL";
export const PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_RESET =
  "PAYMENT_TENANT_GET_STRIPE_PAYMENT_METHODS_RESET";

export const PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_REQUEST =
  "PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_REQUEST";
export const PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_SUCCESS =
  "PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_SUCCESS";
export const PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_FAIL =
  "PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_FAIL";
export const PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_RESET =
  "PAYMENT_UPDATE_SUBSCRIPTION_BILLING_AND_CREATE_SUBSCRIPTION_CHECKOUT_RESET";

export const PAYMENT_TENANT_CANCEL_SUBSCRIPTION_REQUEST =
  "PAYMENT_TENANT_CANCEL_SUBSCRIPTION_REQUEST";
export const PAYMENT_TENANT_CANCEL_SUBSCRIPTION_SUCCESS =
  "PAYMENT_TENANT_CANCEL_SUBSCRIPTION_SUCCESS";
export const PAYMENT_TENANT_CANCEL_SUBSCRIPTION_FAIL =
  "PAYMENT_TENANT_CANCEL_SUBSCRIPTION_FAIL";
export const PAYMENT_TENANT_CANCEL_SUBSCRIPTION_RESET =
  "PAYMENT_TENANT_CANCEL_SUBSCRIPTION_RESET";

export const PAYMENT_TENANT_GET_MODULES_REQUEST =
  "PAYMENT_TENANT_GET_MODULES_REQUEST";
export const PAYMENT_TENANT_GET_MODULES_SUCCESS =
  "PAYMENT_TENANT_GET_MODULES_SUCCESS";
export const PAYMENT_TENANT_GET_MODULES_FAIL =
  "PAYMENT_TENANT_GET_MODULES_FAIL";
export const PAYMENT_TENANT_GET_MODULES_RESET =
  "PAYMENT_TENANT_GET_MODULES_RESET";
